// extracted by mini-css-extract-plugin
export default {"root":"az420FxNkkmPNA49DQiA","wrap":"OVHw7td9eP38iwNO6W3K"};